<template>
  <section class="section --dark --top --triangle-white w-95">
    <div class="employee-card">
      <Transition name="fade-custom">
        <Image :source="slide.image" class="employee-card__image" :key="position" />
      </Transition>
      <div class="employee-card__content">
        <Transition name="fade-custom">
          <div class="employee-card__text-container" :key="position">
            <h2 class="title --uppercase" v-reveal>{{ slide.title }}</h2>
            <p class="description employee-card__quote" v-reveal>{{ slide.quote }}</p>
            <p class="description" v-reveal>{{ slide.description }}</p>
            <div class="employee-card__buttons" v-reveal>
              <InternalLink v-if="slide.buttons?.length" :content="slide.buttons[0]" button />
              <VideoLink v-if="slide.video?.length" :content="slide.video[0]" />
            </div>
          </div>
        </Transition>
      </div>
      <ButtonControls v-if="content.items?.length > 1" :max="content.items.length - 1" :current="position"
        class="employee-card__controls" @increase="position += 1" @decrease="position -= 1" />
    </div>
  </section>
</template>

<script>
import { ButtonControls } from '@/components/blocks'
import { Image } from '@/components/global'
import { InternalLink, VideoLink } from '@/components/small'
import { HasContentMixin } from '@/mixins'

export default {
  name: 'EmployeeSlidesSection',
  components: { ButtonControls, Image, InternalLink, VideoLink },
  mixins: [HasContentMixin],
  computed: {
    slide() {
      return this.content.items[this.position]
    }
  },
  data() {
    return {
      position: 0
    }
  }
}
</script>